export enum SensorSource {
    EKKO_SOFT="ekkoSoft",
    CBRE="cbre",
}